import ForgotPassword from './ForgotPasswordContainer';

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/pages/User/SignIn/components/ForgotPassword/index.js